import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import { useLocalisation } from '@3plearning/lingui-cdn';
import useTranslations from './skill-quests-mastery-legends-translations';

import css from './skill-quests-mastery-legends.scss';

import { SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS } from '../../containers/skill-quests-mastery/skill-quests-mastery-constants';

const SkillQuestsMasteryLegends = ({ variant }) => {
    let legends;

    const {
        CLASS_GROUP_LEVEL,
        STUDENT_ACCURACY,
        STUDENT_PROGRESS
    } = SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS;

    const { i18n } = useLocalisation();
    const {
        CLASS_GROUP_81_TO_100_TEXT,
        CLASS_GROUP_61_TO_80_TEXT,
        CLASS_GROUP_41_TO_60_TEXT,
        CLASS_GROUP_21_TO_40_TEXT,
        CLASS_GROUP_1_TO_20_TEXT,
        STUDENT_PROGRESS_100_TEXT,
        STUDENT_PROGRESS_81_TO_99_TEXT,
        STUDENT_PROGRESS_61_TO_80_TEXT,
        STUDENT_PROGRESS_41_TO_60_TEXT,
        STUDENT_PROGRESS_21_TO_40_TEXT,
        STUDENT_PROGRESS_1_TO_20_TEXT,
        STUDENT_ACCURACY_COMPLETE_TEXT,
        STUDENT_ACCURACY_81_TO_100_TEXT,
        STUDENT_ACCURACY_61_TO_80_TEXT,
        STUDENT_ACCURACY_41_TO_60_TEXT,
        STUDENT_ACCURACY_21_TO_40_TEXT,
        STUDENT_ACCURACY_1_TO_20_TEXT
    } = useTranslations({ i18n });

    switch (variant) {
        case CLASS_GROUP_LEVEL:
            legends = [
                { text: CLASS_GROUP_81_TO_100_TEXT, className: css.green },
                {
                    text: CLASS_GROUP_61_TO_80_TEXT,
                    className: css['light-blue']
                },
                {
                    text: CLASS_GROUP_41_TO_60_TEXT,
                    className: css['dark-blue']
                },
                { text: CLASS_GROUP_21_TO_40_TEXT, className: css.orange },
                { text: CLASS_GROUP_1_TO_20_TEXT, className: css.red }
            ];
            break;
        case STUDENT_PROGRESS:
            legends = [
                {
                    text: STUDENT_PROGRESS_100_TEXT,
                    className: css['progress-complete']
                },
                { text: STUDENT_PROGRESS_81_TO_99_TEXT, className: css.green },
                {
                    text: STUDENT_PROGRESS_61_TO_80_TEXT,
                    className: css['light-blue']
                },
                {
                    text: STUDENT_PROGRESS_41_TO_60_TEXT,
                    className: css['dark-blue']
                },
                { text: STUDENT_PROGRESS_21_TO_40_TEXT, className: css.orange },
                { text: STUDENT_PROGRESS_1_TO_20_TEXT, className: css.red }
            ];
            break;
        case STUDENT_ACCURACY:
            legends = [
                {
                    text: STUDENT_ACCURACY_COMPLETE_TEXT,
                    className: css['accuracy-complete']
                },
                { text: STUDENT_ACCURACY_81_TO_100_TEXT, className: css.green },
                {
                    text: STUDENT_ACCURACY_61_TO_80_TEXT,
                    className: css['light-blue']
                },
                {
                    text: STUDENT_ACCURACY_41_TO_60_TEXT,
                    className: css['dark-blue']
                },
                { text: STUDENT_ACCURACY_21_TO_40_TEXT, className: css.orange },
                { text: STUDENT_ACCURACY_1_TO_20_TEXT, className: css.red }
            ];
            break;
        default:
            break;
    }

    return (
        <div className={css['skill-quests-mastery-legend']}>
            {legends.map((legend) => (
                <div className={css.legend} key={legend.className}>
                    <div className={legend.className} />
                    <div className={css.text}>{legend.text}</div>
                </div>
            ))}
        </div>
    );
};

SkillQuestsMasteryLegends.propTypes = {
    variant: PropTypes.number
};

export default styleable(css)(SkillQuestsMasteryLegends);



// WEBPACK FOOTER //
// ./components/skill-quests-mastery-legends/skill-quests-mastery-legends.js